import {
  ACKNOWLEDGE_PUBLISH,
  BEGIN_PUBLISH,
  INIT,
  PublishState,
  PublishStateType,
  PUBLISH_FAILED,
  PUBLISH_SUCCEEDED,
  SET_PREVIEW_STATE,
  SET_RELEASE_DATE,
  SET_TARGET,
} from 'app/models/ui/publishLesson/constants';
import { createReducer } from 'app/utils/redux';
import { Record } from 'immutable';

const PublishLessonUI = Record({
  lessonID:     null,
  targetID:     null,
  previewState: null,
  releaseDate:  null,
  publishState: new PublishState(),
}, 'PublishLessonUI');

export const publishLessonUIReducer = createReducer(PublishLessonUI(), {
  [INIT]: (state, { lessonID }) => (
    PublishLessonUI({ lessonID })
  ),

  [SET_TARGET]: (state, { id }) => (
    state.set('targetID', id)
  ),

  [SET_RELEASE_DATE]: (state, { releaseDate }) => (
    state.set('releaseDate', releaseDate)
  ),

  [SET_PREVIEW_STATE]: (state, { previewState }) => (
    state.set('previewState', previewState)
  ),

  [ACKNOWLEDGE_PUBLISH]: (state, action) => (
    state.set('publishState', PublishState())
  ),

  [BEGIN_PUBLISH]:     (state, action) => (
    state.set('publishState', PublishState({ state: PublishStateType.Working }))
  ),
  [PUBLISH_SUCCEEDED]: (state, { createdID }) => (
    state.set('publishState', PublishState({ state: PublishStateType.Succeeded, createdID }))
  ),
  [PUBLISH_FAILED]:    (state, { failure }) => (
    state.set('publishState', PublishState({ state: PublishStateType.Failed, failure }))
  ),
});

export default publishLessonUIReducer;
